module.exports = __webpack_public_path__ + "static/img/conversao.66db3db.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/conversao.png
// module id = 2UmB
// module chunks = 1